import Footer from './Footer';
new Footer();
